import React from 'react'
import { Link } from 'react-router-dom'

function Eline() {
    return (
        <div>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">E-line</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/neweline.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">E-line</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Versatile and compact, ideal for medium-sized stores.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">E-LINE is a complete and versatile line of showcases and counters for the service of Coffee Shops, Bakeries, Chocolates, Salads and cooled and hot Take-away. Thanks to its infinite possibility of solutions, also available slimline version, and always with the same look, it adapts to the unique needs of your business.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <div className="flex flex-col gap-3 md:flex-row justify-center items-center">
         <p className="text-xl lg:text-2xl opacity-90">Pastry, Sandwiches, Cold Dishes and Beverages</p>
         <p className="text-xl font-thin opacity-70"><span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       </div>
       <p className="text-xl lg:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
       <p className="text-xl lg:text-2xl opacity-90">Ice cream<span className='text-fuchsia-950'>-18… -15 °C (4L1) -18… -10 °C</span> <span  className='text-gray-400'>(4G3)</span>  </p>
       <p className="text-xl lg:text-2xl opacity-90">Frozen desserts <span className='text-fuchsia-950'>-18… -10 °C</span> <span  className='text-gray-400'>(4G3)</span>  </p>
       <p className="text-xl lg:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(ventilated, ventilated with humidity control)</span><span className='text-red-500'>+65 °C</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Cakes, Sandwiches and Drinks, well visible and always ready for service!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Fan assisted cooling system which assures an even temperature distribution.",
            "Refrigerated storage for easy refill.",
            "Compact exhibitor, with 90 cm depth, is the ideal for spaces where every centimetre counts!.",
            "Support modules (boxes) for service to people with reduced mobility.",
            "LED lightning of high brightness and high energy efficiency..",
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newelinecase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newelinecase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Show your bread to your Customers!</p>
    <ul className="list-[square] list-outside text-gray-500">
        {[
            "Available for bulk, basked or tray exhibition (rear open model).",
            "Easy to clean, with crumb collector.",
            "Vertical bread exhibitor (glass tower).",
            "Compact exhibitor, with 90 cm depth, is the ideal for spaces where every centimetre counts!.",
            "LED lightning of high brightness and high energy efficiency."
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>

             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Candy, pralines, truffles, …, serve your Customers!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Fan assisted system with controlled temperature and humidity.",
            "Vertical exhibitor for candy.",
            "Compact dimensions, with 90 cm depth, are ideal for spaces where every centimeter counts!",
            "Support modules (boxes) for service to people with reduced mobility.",
            "LED lighting of high brightness and high energy efficiency."
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newelinecase2.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 4 */}
            <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
              
        {/* ✅ Image Wrapper */}
        <div className="w-full md:w-1/2">
        <img src="/images/newelinecase3.png" className="max-w-full h-auto object-contain" />
      </div>
    
      <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">A take-away for a complete service!</p>
    <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "Model: fan assisted refrigerated, with refrigerated cover, with heated cover, fan assisted heated, fan assisted heated with humidification and water bath.",
            "Refrigerated or heated storage for an easy stock refill.",
            "Compact exhibitor, with 90 cm depth, is ideal for spaces where every centimetre counts!",
            "LED lighting of high brightness and high energy efficiency."
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>

             </div>
    
          
         </div>
    
         <div className='mb-12 p-4'>
        <p className='text-2xl'>Choose your style!</p>
        <ul className="list-[square] list-outside text-gray-500 text-xl">
        {[
            "4 front glass options: high straight glass (with 2 shelves), low straight glass (with 1 shelf), high convex glass (with 2 shelves), straight glass with aluminium poles (with 2 shelves).",
            "Various lining options to match your business, choice between the CARRÉ, SEASIDE, SIMPLY, TRADITION, TWIST… style.",
            "Under request other colours and coating materials inside and outside the equipment may be used.",
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
    </div>
     </div>
    
  
        </div>
      )
    }
    
export default Eline